import { render, staticRenderFns } from "./ShortcodeGenerator.vue?vue&type=template&id=55f9b0e3&"
import script from "./ShortcodeGenerator.vue?vue&type=script&lang=js&"
export * from "./ShortcodeGenerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports